module.exports = __webpack_public_path__ + "static/media/Samantha M.86e72a66.png";